import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DebugLoggerService {
  log(_message: string, _data?: any): void {
    if (_data !== null && (typeof _data === 'number' || typeof _data === 'boolean')) console.log(_message, _data); // Catches 0 and false.
    else if (_data != undefined) console.log(_message, _data); // If data is defined.
    else console.log(_message); // Just a message was passed.
  }
}